import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../ui/button';

interface RoleAccessHeaderProps {
  onAddRole?: () => void;
}

export default function RoleAccessHeader({ onAddRole }: RoleAccessHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
          <span>Role</span>
          <span>/</span>
          <span>Daftar</span>
        </div>
        <h1 className="text-3xl font-bold">Role</h1>
      </div>

      <Button onClick={onAddRole} className="bg-emerald-600 hover:bg-emerald-700 gap-2">
        <Plus className="w-4 h-4" />
        Tambah Role
      </Button>
    </div>
  );
}
